import { useOktaAuth } from "@okta/okta-react";
import { http } from "./fetch.wrapper";

const useFetch = () => {
    const { oktaAuth } = useOktaAuth();

    const getAccessToken = async (): Promise<string> => {
        const token = oktaAuth.getAccessToken() || "";
        if (token) {
            return token;
        }

        const tokenObj = await oktaAuth.tokenManager.get("accessToken");
        return tokenObj?.accessToken || "";
    };

    async function get<T>(
        path: string,
        crsfToken: string,
        cpContext?: ICPHeaderContext,
        config?: RequestInit
    ): Promise<T> {
        const init = { method: "get", ...config };
        if (cpContext?.isMaint && cpContext?.isCustomer) {
            throw new Error(`Status: 503, Message: `);
        }
        const accessToken = await getAccessToken();
        if (!accessToken) {
            console.warn("useFetch: missing access token", { path, method: "get" });
        }
        return await http<T>(path, init, "get", crsfToken, accessToken);
    }

    async function post<T, U>(
        path: string,
        crsfToken: string,
        body: T,
        cpContext?: ICPHeaderContext,
        config?: RequestInit
    ): Promise<U> {
        const init = { method: "post", body: JSON.stringify(body), ...config };
        if (cpContext?.isMaint && cpContext?.isCustomer) {
            throw new Error(`Status: 503, Message: `);
        }
        const accessToken = await getAccessToken();
        if (!accessToken) {
            console.warn("useFetch: missing access token", { path, method: "post" });
        }
        return await http<U>(path, init, "post", crsfToken, accessToken);
    }

    async function put<T>(
        path: string,
        crsfToken: string,
        body?: T,
        cpContext?: ICPHeaderContext,
        config?: RequestInit
    ): Promise<T> {
        const init = { method: "put", body: JSON.stringify(body), ...config };
        if (cpContext?.isMaint && cpContext?.isCustomer) {
            throw new Error(`Status: 503, Message: `);
        }
        const accessToken = await getAccessToken();
        if (!accessToken) {
            console.warn("useFetch: missing access token", { path, method: "put" });
        }
        return await http<T>(path, init, "put", crsfToken, accessToken);
    }

    return {
        get,
        post,
        put
    };
};

export default useFetch;
